import React from 'react';
import TopBar from "../components/TopBar";
import Footer from "../components/Footer";
import ContactForm from '../components/ContactForm';
import "../App.css";

function OurTeam() {
  return (
    <div className="App">
      <TopBar />
      <div className="App-header-services" style={{ padding: '8vw 8px 8px 8px', marginBottom: '10vh', minHeight: '60vh' }}>
        <div className="our-team-text" style={{ maxWidth: '800px', margin: '0 auto', textAlign: 'center' }}>
          <h1 className="hero-title">Our Team</h1>
          <p className="hero-subtitle" style={{ fontSize: '1.2rem', color: '#333', marginBottom: '32px' }}>
            At the heart of our care is a team that truly cares. Our professionals come from diverse backgrounds in caregiving, personal support work, nursing, housekeeping, and many more — all united by one mission: to provide compassionate, reliable, and personalized care for your loved ones. We believe that great care starts with genuine connection. That’s why our professional team works closely with you and your family to create a personalized care plan that grows and adapts with your needs, and you will be able to choose and monitor from daily support to specialized care with us, we’re here every step of the way — with kindness, consistency, and heart.
          </p>
          <p className="hero-subtitle" style={{ fontSize: '1.2rem', color: '#333', marginBottom: '32px' }}>
                        We understand the weight of caregiving responsibilities, and this is not an easy way to walk along by yourself.  And aside from governments' support is always not enough, that's why we're here to help lift that burden. With our reliable, professional, and compassionate team by your side, you can focus on what matters most — spending quality time with your loved one while we take care of the rest.
          </p>
          <div style={{ margin: '40px auto', maxWidth: '800px', width: '100%' }}>
            <img 
              src="/group.jpg"
              alt="Connection Health Care Team" 
              style={{ 
                width: '100%', 
                height: 'auto', 
                borderRadius: '12px',
                boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
              }} 
            />
          </div>
          {/* <div className="team-members" style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: '20px' }}>
            <div className="team-card" style={{ width: '200px', textAlign: 'center' }}>
              <img src="/images/james.jpg" alt="James" style={{ width: '100%', borderRadius: '50%' }} />
              <h3>James</h3>
              <p>Founder & CEO</p>
            </div>
            <div className="team-card" style={{ width: '200px', textAlign: 'center' }}>
              <img src="/images/elderly-care.jpg" alt="Sarah" style={{ width: '100%', borderRadius: '50%' }} />
              <h3>Sarah</h3>
              <p>Care Manager</p>
            </div>
          </div> */}
        </div>
      </div>
      <ContactForm />
      <Footer />
    </div>
  );
}

export default OurTeam;